export { ReactComponent as searchIcon } from './search.svg';
export { ReactComponent as candlestickChartIcon } from './candlesticks-chart.svg';
export { ReactComponent as lineChartIcon } from './line-chart.svg';
export { ReactComponent as pencilIcon } from './pencil.svg';
export { ReactComponent as tralentQuantityIcon } from './tralent-quantity.svg';
export { ReactComponent as crossIcon } from './cross.svg';
export { ReactComponent as checkCircleIcon } from './check-circle.svg';
export { ReactComponent as crossCircleIcon } from './cross-circle.svg';
export { ReactComponent as exclamationCircleIcon } from './exclamation-circle.svg';
export { ReactComponent as infoCircleIcon } from './info-circle.svg';
export { ReactComponent as loaderIcon } from './loader.svg';
export { ReactComponent as tralentLoaderIcon } from './tralent-loader.svg';
export { ReactComponent as checkIcon } from './check.svg';
export { ReactComponent as cupIcon } from './cup.svg';
export { ReactComponent as participantsIcon } from './participants.svg';
export { ReactComponent as bookIcon } from './book.svg';
export { ReactComponent as infoCircleOutlineIcon } from './info-circle-outline.svg';
export { ReactComponent as infoCircleDashedIcon } from './info-circle-dashed.svg';
export { ReactComponent as tournamentQuickIcon } from './tournament-quick.svg';
export { ReactComponent as tournament1HourIcon } from './tournament-1h.svg';
export { ReactComponent as tournament4HourIcon } from './tournament-4h.svg';
export { ReactComponent as tournamentDailyIcon } from './tournament-1d.svg';
export { ReactComponent as tournamentWeeklyIcon } from './tournament-1w.svg';
export { ReactComponent as tournamentCustomIcon } from './tournament-custom.svg';
export { ReactComponent as walletIcon } from './wallet.svg';
export { ReactComponent as plusCircleIcon } from './plus-circle.svg';
export { ReactComponent as plusIcon } from './plus.svg';
export { ReactComponent as minusCircleIcon } from './minus-circle.svg';
export { ReactComponent as minusIcon } from './minus.svg';
export { ReactComponent as arrowCandlestickIcon } from './arrow-candlestick.svg';
export { ReactComponent as creditCardIcon } from './credit-card.svg';
export { ReactComponent as eyeOpenOutlined } from './eye-open-outlined.svg';
export { ReactComponent as eyeClosedOutlined } from './eye-closed-outlined.svg';
export { ReactComponent as chevronLeft } from './chevron-left.svg';
export { ReactComponent as chevronRight } from './chevron-right.svg';
export { ReactComponent as chevronDown } from './chevron-down.svg';
export { ReactComponent as chevronTop } from './chevron-top.svg';
export { ReactComponent as podiumIcon } from './podium.svg';
export { ReactComponent as podiumBicolorIcon } from './podium-bicolor.svg';
export { ReactComponent as lockIcon } from './lock.svg';
export { ReactComponent as deskCalendarIcon } from './desk-calendar.svg';
export { ReactComponent as calendarIcon } from './calendar.svg';
export { ReactComponent as filterIcon } from './filter.svg';
export { ReactComponent as resetIcon } from './reset.svg';
export { ReactComponent as arrowTopIcon } from './arrow-top.svg';
export { ReactComponent as arrowRightIcon } from './arrow-right.svg';
export { ReactComponent as arrowBottomIcon } from './arrow-bottom.svg';
export { ReactComponent as arrowLeftIcon } from './arrow-left.svg';
export { ReactComponent as questionMarkCircleIcon } from './question-mark.svg';
export { ReactComponent as mailIcon } from './mail.svg';
export { ReactComponent as usersIcon } from './users.svg';
export { ReactComponent as fireFillIcon } from './fire-fill.svg';
export { ReactComponent as fireIcon } from './fire-outline.svg';
export { ReactComponent as candlestickIcon } from './candlestick.svg';
export { ReactComponent as emptyTralentStateIcon } from './empty_tralent_state.svg';
export { ReactComponent as oneIcon } from './one.svg';
export { ReactComponent as twoIcon } from './two.svg';
export { ReactComponent as copyIcon } from './copy.svg';
export { ReactComponent as reportIcon } from './report.svg';
export { ReactComponent as sortingIcon } from './sorting.svg';
export { ReactComponent as clockCircleIcon } from './clock-circle.svg';
export { ReactComponent as playCircleIcon } from './play-circle.svg';
export { ReactComponent as logoutIcon } from './logout.svg';
export { ReactComponent as gearIcon } from './gear.svg';
export { ReactComponent as linkIcon } from './link.svg';
export { ReactComponent as puzzleIcon } from './puzzle.svg';
export { ReactComponent as moneyIcon } from './money.svg';
export { ReactComponent as moneyBagIcon } from './money-bag.svg';
export { ReactComponent as shiningIcon } from './shining.svg';
export { ReactComponent as bellIcon } from './bell.svg';
export { ReactComponent as userIcon } from './user.svg';
export { ReactComponent as locationIcon } from './location.svg';
export { ReactComponent as shieldIcon } from './shield.svg';
export { ReactComponent as hourglassIcon } from './hourglass.svg';
export { ReactComponent as ticketFillIcon } from './ticket.svg';
export { ReactComponent as ticketIcon } from './ticket-linear.svg';
export { ReactComponent as ticketSquareIcon } from './ticket-square-linear.svg';
export { ReactComponent as shapesIcon } from './shapes.svg';
export { ReactComponent as headphonesIcon } from './headphones.svg';
export { ReactComponent as walletInIcon } from './wallet-in.svg';
export { ReactComponent as stampIcon } from './stamp.svg';
export { ReactComponent as dashedCircleIcon } from './dashed-circle.svg';
export { ReactComponent as upSlashDownIcon } from './up-slash-down.svg';
export { ReactComponent as scanUserIcon } from './scan-user.svg';
export { ReactComponent as bankIcon } from './bank.svg';
export { ReactComponent as lightningIcon } from './lightning.svg';
export { ReactComponent as slidersIcon } from './sliders.svg';
export { ReactComponent as criptoIcon } from './cripto.svg';
export { ReactComponent as playIcon } from './play.svg';
export { ReactComponent as phoneIcon } from './phone.svg';
export { ReactComponent as inboxIcon } from './inbox.svg';
export { ReactComponent as quickTimerIcon } from './quick-timer.svg';
export { ReactComponent as iosAddSquareIcon } from './ios-add-square.svg';
export { ReactComponent as iosShareIcon } from './ios-share.svg';
export { ReactComponent as homeIcon } from './home.svg';
export { ReactComponent as clockArrowIcon } from './clock-arrow-linear.svg';
export { ReactComponent as arrowReverseIcon } from './arrows-reverse-linear.svg';
export { ReactComponent as trashIcon } from './trash.svg';
export { ReactComponent as uploadIcon } from './upload-linear.svg';
export { ReactComponent as fileIcon } from './file-linear.svg';
export { ReactComponent as cryptoIcon } from './crypto.svg';
